/**
 * Makes the Shopify dynamic checkout "Buy it now" button add the item to the
 * cart (so add-to-cart analytics/pixels fire) before sending the customer to checkout.
 *
 * The native "Buy it now" button skips /cart/add.js entirely, so any app or
 * script that tracks "add to cart" by watching that request never fires for it.
 * We intercept the click in the capture phase (before Shopify's own handler
 * runs), add the item via the real cart/add.js endpoint, then redirect to
 * checkout ourselves.
 *
 * Branded wallet buttons (Shop Pay, PayPal, Google Pay, etc.) render inside a
 * cross-origin iframe and cannot be intercepted this way — this only covers
 * the plain "Buy it now" button.
 *
 * The "Buy it now" button itself is rendered inside a shadow-DOM web
 * component, so `event.target` gets retargeted to the outer custom element
 * and a plain `.closest()` call never finds the real button/form. We use
 * `event.composedPath()` instead, which sees through the shadow boundary.
 */
(function () {
  if (window.__buyNowAddToCartInit) return;
  window.__buyNowAddToCartInit = true;

  document.addEventListener(
    'click',
    function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];

      var buyNowBtn = path.find(function (el) {
        return (
          el.nodeType === 1 &&
          el.classList &&
          el.classList.contains('shopify-payment-button__button--unbranded')
        );
      });
      if (!buyNowBtn) return;

      if (buyNowBtn.getAttribute('aria-disabled') === 'true' || buyNowBtn.disabled) return;

      var form = path.find(function (el) {
        return el.nodeType === 1 && el.tagName === 'FORM';
      });
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (buyNowBtn.dataset.buyNowProcessing === 'true') return;
      buyNowBtn.dataset.buyNowProcessing = 'true';
      buyNowBtn.classList.add('is-loading');

      // Some other part of the cart pipeline flips this class to pop open the
      // mini-cart drawer whenever an item is added. Suppress it for this flow
      // (both via CSS and by stripping it back off if something sets it) so
      // the drawer doesn't flash open right before we redirect to checkout.
      document.body.classList.add('buy-now-checkout');
      var suppressDrawer = new MutationObserver(function () {
        if (document.body.classList.contains('cart-sidebar-show')) {
          document.body.classList.remove('cart-sidebar-show');
        }
      });
      suppressDrawer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      var cartAddUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + 'cart/add.js') ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add.js';
      var checkoutUrl = ((window.routes && window.routes.cart) || '/cart') + '/checkout';

      var formData = new FormData(form);

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.status) {
            suppressDrawer.disconnect();
            document.body.classList.remove('buy-now-checkout');
            buyNowBtn.dataset.buyNowProcessing = 'false';
            buyNowBtn.classList.remove('is-loading');
            if (data.description) alert(data.description);
            return;
          }

          document.dispatchEvent(
            new CustomEvent('product:added', { bubbles: true, detail: { item: data } })
          );

          window.location.href = checkoutUrl;
        })
        .catch(function (error) {
          console.error('Buy now add to cart failed:', error);
          suppressDrawer.disconnect();
          document.body.classList.remove('buy-now-checkout');
          buyNowBtn.dataset.buyNowProcessing = 'false';
          buyNowBtn.classList.remove('is-loading');
        });
    },
    true
  );
})();
